module.exports = __webpack_public_path__ + "img/65.ef433035.png";